<a class="fullscreenButton cursor" (click)="toggleFullScreen()">
    <kh-img class="full-screen-img" path="fullscreen-icon.png"></kh-img>
</a>
